import { makeContextModule } from '@cian/react-utils';

import { IOffer } from '../../types/offer';

export const {
  Context: OfferContext,
  useContext: useOfferContext,
  withContext: withOfferContext,
} = makeContextModule<IOffer>({
  contextName: 'OfferContext',
});
